import { render } from "./ContactTestView.vue?vue&type=template&id=7c0627ce"
import script from "./ContactTestView.vue?vue&type=script&lang=js"
export * from "./ContactTestView.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__